import type { PunchEvent } from '../types/employee';

export const PUNCH_STORAGE_KEY = 'garderie-punch-events';
const PUNCH_BROADCAST_CHANNEL = 'garderie-punch-sync';

let punchBroadcastChannel: BroadcastChannel | null = null;

function getPunchBroadcastChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!punchBroadcastChannel) {
    punchBroadcastChannel = new BroadcastChannel(PUNCH_BROADCAST_CHANNEL);
  }
  return punchBroadcastChannel;
}

export function loadPunchEvents(): PunchEvent[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(PUNCH_STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as PunchEvent[];
  } catch {
    return [];
  }
}

export function savePunchEvents(events: PunchEvent[], options?: { notify?: boolean }): void {
  if (typeof window === 'undefined') return;
  const notify = options?.notify !== false;
  try {
    localStorage.setItem(PUNCH_STORAGE_KEY, JSON.stringify(events));
    if (!notify) return;
    window.dispatchEvent(new CustomEvent('garderie:punch-updated'));
    getPunchBroadcastChannel()?.postMessage('updated');
  } catch {
    // ignore
  }
}

export function subscribeToPunchStorage(onUpdate: () => void): () => void {
  if (typeof window === 'undefined') return () => {};

  // Cross-tab only — same-tab updates already flow through React state.
  const onStorage = (event: StorageEvent) => {
    if (event.key === PUNCH_STORAGE_KEY) onUpdate();
  };
  const channel = getPunchBroadcastChannel();
  const onBroadcast = () => onUpdate();

  window.addEventListener('storage', onStorage);
  channel?.addEventListener('message', onBroadcast);

  return () => {
    window.removeEventListener('storage', onStorage);
    channel?.removeEventListener('message', onBroadcast);
  };
}

export function notifyPunchRecorded(): void {
  window.dispatchEvent(new CustomEvent('garderie:punch'));
}

export function notifyPunchStorageUpdated(): void {
  window.dispatchEvent(new CustomEvent('garderie:punch-updated'));
}
